import './loadjQuery.js';
import $ from 'jquery';
import '@popperjs/core';
import * as bootstrap from 'bootstrap';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

//import 'bootstrap/dist/css/bootstrap.css';
// Custom JS imports
import './vendor/jquery.lbt-lightbox.js';
import './map.js';
import * as Utility from './utility.js';
import * as Helper from './helper.js';
import Autocomplete from './autocomplete.js';
import './search.js';

// Custom CSS imports
import '../scss/custom.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/vendor/jquery.lbt-lightbox.css';

import 'overlayscrollbars/overlayscrollbars.css';
import {
    OverlayScrollbars,
    ScrollbarsHidingPlugin,
    SizeObserverPlugin,
    ClickScrollPlugin,
} from 'overlayscrollbars';

import '../css/site.css';

// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// Write your JavaScript code.
let LIGHTBOX_GALLERY_INSTANCES = {};
document.addEventListener('DOMContentLoaded', function () {
    console.log('[DOMContentLoaded]');
    initializeLightBoxGallery();
    initializeHomePageCitySelectorCookieAndClicks();
    initializeScrollableRecentBusinesses();
    bindScrollEventOnAdvertisement();
    bindOpenNewTabElements();
    bindCategoryBadgeOnBlogListPage();
    initializeOverlayScrollbars();
    //bindAutocompleteForSearchInput();

    function initializeOverlayScrollbars() {
        const content = document.querySelector('.overflow-mobile-scroll-container__content');
        if (content) {
            const prevBtn = document.querySelector('.saasapp-arrow--left');
            const nextBtn = document.querySelector('.saasapp-arrow--right');

            if (!content || !prevBtn || !nextBtn) return;

            const cards = Array.from(content.children);
            let currentIndex = 0;

            function scrollToCard(index) {
                const card = cards[index];

                content.scrollTo({
                    left: card.offsetLeft,
                    behavior: 'smooth',
                });

                updateButtons();
            }

            function updateButtons() {
                prevBtn.disabled = currentIndex === 0;
                nextBtn.disabled = currentIndex === cards.length - 1;
            }

            nextBtn.addEventListener('click', () => {
                if (currentIndex < cards.length - 1) {
                    currentIndex++;
                    scrollToCard(currentIndex);
                }
            });

            prevBtn.addEventListener('click', () => {
                if (currentIndex > 0) {
                    currentIndex--;
                    scrollToCard(currentIndex);
                }
            });

            // Sync index when user swipes manually
            content.addEventListener('scroll', () => {
                let closestIndex = 0;
                let closestDistance = Infinity;

                cards.forEach((card, index) => {
                    const distance = Math.abs(card.offsetLeft - content.scrollLeft);

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestIndex = index;
                    }
                });

                currentIndex = closestIndex;
                updateButtons();
            });

            updateButtons();
        }
    }

    function bindAutocompleteForSearchInput() {
        document.querySelectorAll('.saasapp-autocomplete').forEach((input) => {
            const apiUrl = input.dataset.autocomplete;
            const selector = input.dataset.source;

            const textField = input.dataset.textField || 'name';
            const valueField = input.dataset.valueField || 'id';

            let dataSource;

            // API source
            if (apiUrl) {
                dataSource = async (query) => {
                    const res = await fetch(`${apiUrl}?q=${encodeURIComponent(query)}`);
                    return await res.json();
                };
            }

            // selector source
            else if (selector) {
                const sourceEl = document.querySelector(selector);

                let items = [];

                if (sourceEl.tagName === 'SELECT') {
                    items = [...sourceEl.options].map((o) => ({
                        id: o.value,
                        name: o.text,
                    }));
                } else {
                    items = [...sourceEl.children].map((el) => ({
                        id: el.dataset.id,
                        name: el.textContent,
                    }));
                }

                dataSource = async (query) => {
                    return items.filter((x) => x.name.toLowerCase().includes(query.toLowerCase()));
                };
            }

            if (dataSource) {
                new Autocomplete(input, dataSource, {
                    textField,
                    valueField,
                });
            }
        });
    }

    function initializeLightBoxGallery() {
        $('.light-box-gallery-container').each(function (index, element) {
            let galleryId = element.id;
            LIGHTBOX_GALLERY_INSTANCES[galleryId] = $('#' + galleryId).lbtLightBox({
                qtd_pagination: 4,
                pagination_width: '120px',
                pagination_height: '120px',
                custom_children: '.box img',
                captions: true,
                captions_selector: '.caption p',
            });
        });
    }

    function initializeScrollableRecentBusinesses() {
        let recentHomeItems = document.querySelectorAll(
            '#carouselRecentlyAddedBusinesses .carousel-item'
        );

        recentHomeItems.forEach((el) => {
            const minPerSlide = 2;
            let next = el.nextElementSibling;
            for (var i = 1; i < minPerSlide; i++) {
                if (!next) {
                    // wrap carousel by using first child
                    next = recentHomeItems[0];
                }
                let cloneChild = next.cloneNode(true);
                el.appendChild(cloneChild.children[0]);
                next = next.nextElementSibling;
            }
        });
    }

    function initializeHomePageCitySelectorCookieAndClicks() {
        $('.home-page-city-selector').on('change', function (e) {
            if ($(this).val()) {
                let selectedCity = $(this).val();
                if (selectedCity) {
                    let cookieName = $(this).attr('data-ckname');
                    if (cookieName !== undefined) {
                        Helper.setCookie(cookieName, selectedCity, 7);
                    }
                }
            } else {
                let cookieName = $(this).attr('data-ckname');
                if (cookieName !== undefined) {
                    Helper.clearCookie(cookieName);
                }
            }
        });
        $('.home-page-city-go').on('click', function (e) {
            let selectedCity = $('.home-page-city-selector').val();
            let categoryId = $('#categorySelectOptions').val();
            let urlParams = '';
            if (categoryId) {
                urlParams = '?categories=' + categoryId;
            }
            if (selectedCity) {
                window.location.href = Utility.getAbsolutePath(
                    '/discover/' + selectedCity + urlParams
                );
            } else {
                window.location.href = Utility.getAbsolutePath('/discover/calgary--ab' + urlParams);
            }
        });
    }

    function bindOpenNewTabElements() {
        $('.target-click-to-tab').on('click', function (e) {
            console.log(e);
            let url = e.currentTarget.dataset.link;
            let adid = e.currentTarget.dataset.ad;
            let adownerid = e.currentTarget.dataset.adowner;
            if (adid && adownerid && adid.length > 0) {
                let data = { adid, adownerid };
                const cevent = new CustomEvent('adclick', { detail: data });
                document.dispatchEvent(cevent);
            }
            if (url && url.length > 0) {
                window.open(url, '_blank', 'noopener,noreferrer');
            }
        });
    }

    function bindScrollEventOnAdvertisement() {
        let element = document.getElementById('searchResultContainerList');
        if (element) {
            console.log('[bindScrollEventOnAdvertisement] if');
            element.addEventListener('scroll', initializeAdImpression);
        } else {
            console.log('[bindScrollEventOnAdvertisement] else');
        }
    }

    function initializeAdImpression() {
        let element = document.getElementById('saasappAdvertisementPlaceholder');
        if (element) {
            let isVisibleinview = isInViewport(element);
            if (isVisibleinview && isVisibleinview == true) {
                let adElement = document.getElementById('saasappAdvertisementPlaceholder');
                if (!Utility.isImpressionTracked(adElement)) {
                    Utility.setImpressionTracked(adElement);
                    let adid = adElement.dataset.ad;
                    let adownerid = adElement.dataset.adowner;
                    if (adid && adownerid && adid.length > 0) {
                        console.log('[initializeAdImpression] setImpressionTracked event' + adid);
                        let data = { adid, adownerid };
                        const cevent = new CustomEvent('adimpression', { detail: data });
                        document.dispatchEvent(cevent);
                    }
                }
            }
        }
    }

    function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    }

    function bindCategoryBadgeOnBlogListPage() {
        $('.saasapp-category-badge').each(function (index, element) {
            $(element).on('click', function (event) {
                if ($(this).hasClass('selected')) {
                    $(this).removeClass('selected');
                } else {
                    $(this).addClass('selected');
                }
                processCategoryChange();
            });
        });
        $('.saasapp-category-page-navigation').each(function (index, element) {
            $(element).on('click', function (event) {
                event.preventDefault();
                processBlogPageNavigationChange(this);
            });
        });
    }
    function getAllSelectedCategorySlugList() {
        let categoryList = [];
        $('.saasapp-category-badge').each(function (index, element) {
            if ($(this).hasClass('selected')) {
                if (element.dataset && element.dataset.slug) {
                    categoryList.push(element.dataset.slug);
                }
            }
        });
        return categoryList;
    }
    function processCategoryChange() {
        let categoryList = getAllSelectedCategorySlugList();
        if (categoryList && categoryList.length > 0) {
            let categories = categoryList.join(',');
            window.location.href = Utility.getAbsolutePath('/blog/?categories=' + categories);
        } else {
            window.location.href = Utility.getAbsolutePath('/blog/');
        }
    }
    function processBlogPageNavigationChange(currentElement) {
        let dataset = currentElement.dataset;
        //console.log(dataset);
        let params = new URL(document.location).searchParams;
        let categories = params.get('categories');
        let searchParams = [];
        if (categories && categories != null) {
            searchParams.push('categories=' + categories);
        }
        if (dataset) {
            if (dataset.pageNumber && parseInt(dataset.pageNumber) > 0) {
                searchParams.push('page=' + parseInt(dataset.pageNumber));
            }
        }
        if (searchParams && searchParams.length > 0) {
            window.location.href = Utility.getAbsolutePath('/blog/?' + searchParams.join('&'));
        } else {
            window.location.href = Utility.getAbsolutePath('/blog');
        }
    }
});
